import { memo } from 'react';
import { Link as RRLink } from 'react-router-dom';

type Props = {
  to: string;
  children: React.ReactNode;
  color?: string;
  textDecoration?: string;
};

const Link = ({
  to,
  children,
  color = 'inherit',
  textDecoration = 'none',
}: Props) => {
  return (
    <RRLink to={to} style={{ textDecoration, color }}>
      {children}
    </RRLink>
  );
};

export default memo(Link);
